module.exports = __webpack_public_path__ + "static/media/union_news_website_logo_transparent_background.7e952f54.png";